<template>
  <router-view />
</template>

<script>
export default {
  name: "AppProjects"
};
</script>

<style lang="scss" scoped></style>
